<template>
  <div
    :class="['other-page', {
      'other-page--funnel': isFunnelPage,
      'other-page--article': isArticlePage,
      'other-page--partner': isPartnerPage,
      'other-page--with-background': hasBackground
    }]"
  >
    <div class="inner">
      <div
        v-if="$slots['module']"
        :class="['module', {
          'module--no-margin': !breadcrumbs.length && !title && !showStatusLabel && !subTitle && !$slots['sub-title']
        }]"
      >
        <slot name="module" />
      </div>

      <zg-breadcrumb
        v-if="breadcrumbs.length"
        :bread-crumbs="breadcrumbs"
        :class="['breadcrumbs', {
          'breadcrumbs--no-margin': !title && !showStatusLabel && !subTitle && !$slots['sub-title']
        }]"
      />

      <div
        v-if="title || showStatusLabel"
        :class="['title', {
          'title--no-margin': !subTitle && !$slots['sub-title']
        }]"
      >
        <h1
          v-if="title"
          v-html="title"
        />

        <zg-label
          v-if="showStatusLabel"
          :text="status.text"
          :icons="{ right: status.icon }"
          :background="status.background"
          no-margin
        />
      </div>

      <p
        v-if="subTitle"
        class="sub-title"
        v-html="subTitle"
      />

      <div
        v-else-if="$slots['sub-title']"
        class="sub-title"
      >
        <slot name="sub-title" />
      </div>

      <div
        v-else-if="$slots['content']"
        class="content"
      >
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
  import ZgBreadcrumb from '../ZgBreadCrumb/ZgBreadCrumb'
  import ZgLabel from '../ZgLabel/ZgLabel'

  export default {
    name: 'OtherPage',
    components: {
      ZgBreadcrumb,
      ZgLabel
    },
    props: {
      isFunnelPage: {
        type: Boolean,
        required: false,
        default: false
      },
      isArticlePage: {
        type: Boolean,
        required: false,
        default: false
      },
      isPartnerPage: {
        type: Boolean,
        required: false,
        default: false
      },
      title: {
        type: String,
        required: false,
        default: null
      },
      subTitle: {
        type: String,
        required: false,
        default: null
      },
      hasBackground: {
        type: Boolean,
        required: false,
        default: false
      },
      status: {
        type: Object,
        required: false,
        default: null
      },
      breadcrumbs: {
        type: Array,
        required: false,
        default: null
      }
    },
    computed: {
      showStatusLabel () {
        return this.status?.text && this.status?.icon && this.status?.background
      }
    }
  }
</script>

<style lang="scss" scoped>
  $content-max-width: 1176px; // 1080px plus 48px padding on each side

  .other-page {
    position: relative;
    width: 100%;
    padding: rem(32px) rem(16px) rem(24px);
    margin: rem(24px) auto 0;
    border-radius: rem(32px) rem(32px) 0 0;

    @include mq($content-max-width) {
      max-width: $content-max-width;
      padding: rem(48px) rem(48px) rem(24px);
      border-radius: rem(48px) rem(48px) 0 0;
    }

    .inner {
      max-width: rem(1080px);
      display: flex;
      flex-direction: column;
      margin: 0 auto;
    }

    .breadcrumbs {
      margin: 0 0 rem(12px);

      &--no-margin {
        margin: 0;
      }
    }

    .title {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      gap: rem(24px);
      margin: 0 0 rem(12px);

      &--no-margin {
        margin: 0;
      }
    }

    h1 {
      @include type-title-xl;

      margin: 0;

      @include mq(medium) {
        @include type-title-xxl;

        margin: 0;
      }
    }

    .sub-title {
      margin: 0;

      ::v-deep p {
        margin: 0 0 rem(8px);

        &:last-child {
          margin: 0;
        }
      }
    }

    .module {
      margin: 0 0 rem(24px);

      &--no-margin {
        margin: 0;
      }

      ::v-deep > div {
        margin: 0;
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // types
  // ? ----------------------------------------------------------------------

  .other-page--funnel {
    background-color: color(beige);

    @include mq(large) {
      &::after {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        content: '';
        background-color: color(beige);
        height: rem(160px);
      }
    }
  }

  .other-page--article,
  .other-page--partner {
    background-color: color(white);

    @include mq(large) {
      &::after {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        content: '';
        background-color: color(white);
        height: rem(160px);
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // modifiers
  // ? ----------------------------------------------------------------------

  .other-page--with-background {
    margin: rem(145px) auto 0;

    @include mq(medium) {
      margin: rem(256px) auto 0;
    }

    @include mq(large) {
      margin: rem(297px) auto 0;
    }
  }
</style>
